import { gql } from "@apollo/client";

export const GET_ZIPCODE_MAP_BOUNDARIES_BY_AREA_ID = gql`
    query GetZipcodeMapBoundariesByAreaId($areaId: Long!) {
        getZipcodeMapBoundariesByAreaId(areaId: $areaId) {
            zipcode
            geometryType
            boundary
        }
    }
`;

export interface ZipcodeMapBoundaryByAreaItem {
    zipcode: string;
    geometryType: string;
    boundary: string;
}

export interface GetZipcodeMapBoundariesByAreaIdResponse {
    getZipcodeMapBoundariesByAreaId: ZipcodeMapBoundaryByAreaItem[];
}

export interface GetZipcodeMapBoundariesByAreaIdVariables {
    areaId: number;
}
